import { useMutation } from "react-query";
// import TableComponent from "../../../Reports/component/TableComponent";
import { getAllHIstory, getLogsDetails } from "../../services";
import {
  Button,
  Collapse,
  IconButton,
  styled,
  Table,
  TableCell,
  tableCellClasses,
  TableContainer,
  //   TableFooter,
  //   TableFooter,
  TableHead,
  //   TablePagination,
  TableRow,
  // IconButton,
  Tooltip,
} from "@mui/material";
import usePopup from "../../../hooks/usePopup";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import CustomTableBody from "@utilifiles/component/CustomTableBody";
import moment from "moment";
import { formatLocalDateTime } from "@utilifiles/methods/localDateTime";
import { LogComponentType, LogFieldType } from "./types";
import ListAltIcon from "@mui/icons-material/ListAlt";
const headings = [
  "Slno",
  "Action type",
  "New value",
  "Old value",
  "Affected field",
  "Time",
  "Modified by",
];
// import LogComonent from "./LogComonent";
// import { ListAlt } from "@mui/icons-material"
const HistoryComponent = ({
  title,
  tableprops,
  logProps,
}: {
  title: keyof typeof titles;
  tableprops: {
    heading: string;
    key: string;
    date?: string;
    format?: string;
    numberType?: string;
  }[];
  logProps?: LogComponentType | null;
}) => {
  const { CustomModal, showSnackbar } = usePopup();
  const { patientId } = useParams();
  const [openHistory, setOpenHistory] = useState<boolean>(false);

  const rowsPerPage = 10;
  const page = 0;

  const { data, isLoading, mutate } = useMutation(getAllHIstory);

  const effectivePage = page;
  const effectiveRowsPerPage = rowsPerPage;
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      fontSize: 10,
      fontWeight: 600,
      padding: "2px 6px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 20,
      padding: "4px 178px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      lineHeight: 1.6, //
    },
  }));

  const handleOpenHistory = () => {
    setOpenHistory(true);
    mutate({
      id: Number(patientId),
      tab: titles[title],
    });
  };

  function getNestedValue(obj: any, key: string) {
    const splited = key.split(".");
    if (splited.length > 1) {
      return splited.reduce((acc: any, curr: string) => {
        if (acc && typeof acc === "object" && curr in acc) {
          return acc[curr];
        }
        return undefined;
      }, obj);
    } else {
      return obj[key];
    }
  }

  function resolveValue(value: any) {
    if (value == null) return "";

    if (typeof value !== "object")
      return String(value === 0 ? "0" : (value || "")).replace(/#\$/g, " ");

    if ("value" in value) return value.value;

    if ("name" in value) return value.name;
    return JSON.stringify(value);
  }

  const renderCellValue = (row: any, tableProp: any) => {
    let value = getNestedValue(row, tableProp.key);
    if (value || value === 0) {
      if (tableProp?.date) {
        let m = tableProp?.format
          ? moment(value, tableProp.format, true)
          : moment.invalid();
        if (!m.isValid()) {
          m = moment(value);
        }
        return m.isValid()
          ? m.format(
              typeof tableProp.date === "string" ? tableProp.date : "DD-MM-YYYY",
            )
          : String(value ?? "");
      }
      if (Boolean(tableProp.numberType)) {
        return tableProp.numberType === "round"
          ? Number(value).toFixed(2)
          : `${value}`;
      }
      
      if (typeof value === "number") {
        return `${value}`;
      }

      const displayValue = resolveValue(value);

      if (tableProp.key === "notes" || tableProp.key === "medication") {
        return (
          <Tooltip title={displayValue || ""} arrow placement="right">
            <span
              style={{
                display: "inline-block",
                maxWidth: 200,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                cursor: "pointer",
              }}
            >
              {displayValue}
            </span>
          </Tooltip>
        );
      }

      return displayValue;
    }
    return "";
  };

  // const renderdata = useMemo(() => {
  //   return Object.values(
  //     (data?.response?.[titles[title]] || []).reduce((acc: any, item: any) => {
  //       const id = item.encounterId;

  //       if (!acc[id]) {
  //         acc[id] = {
  //           encounterId: id,
  //           data: [],
  //         };
  //       }

  //       acc[id].data.push(item);

  //       return acc;
  //     }, {}),
  //   );
  // }, [data?.response]);

  const [open, setOpen] = useState<string | null>(null);

  const {
    mutate: fetchLogsDetails,
    data: logs,
    isLoading: logLoading,
  } = useMutation(getLogsDetails, {
    onSuccess: (result) => {
      if (result.responseIndicator == "fail") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
        });
      }
    },
  });

  const handleOpenLog = (encounterId: string) => {
    open == encounterId ? setOpen(null) : setOpen(encounterId);
    fetchLogsDetails({ field: logApi[titles[title] as keyof typeof logApi] as LogFieldType, encounterId });
  };

  // const renderdata = useMemo(() => {
  //   return data?.response?.[titles[title]] || [];
  // }, [data?.response]);

  const renderdata = useMemo(() => {
    const list = data?.response?.[titles[title]] || [];

    if (!list.length) return [];

    // case 1: already grouped (Lab)
    if (list[0]?.data) {
      return list;
    }

    // case 2: flat array (Medical History)
    return Object.values(
      list.reduce((acc: any, item: any) => {
        const id = item.encounter || item.encounterId;

        if (!acc[id]) {
          acc[id] = {
            encounterId: id,
            data: [],
          };
        }

        acc[id].data.push(item);

        return acc;
      }, {})
    );
  }, [data?.response]);
  useEffect(() => {
    console.log(open);
  }, [open]);
  return (
    <>
      <CustomModal
        title={`Previous ${title}`}
        open={openHistory}
        setOpen={setOpenHistory}
      >
        <div className="p-2 max-h-[80dvh] overflow-y-auto">
          {/* <TableComponent
            data={data?.response?.[titles[title]] || []}
            tableProps={tableprops}
            pagination="frontend"
            loading={isLoading}
          /> */}
          <Table
            size="small"
            stickyHeader
            sx={{
              minWidth: 200, // reduced from 500
              tableLayout: "auto", // columns auto-resize to fit content
              borderRight: "1px solid #ccc",
            }}
            aria-label="custom pagination table"
          >
            <TableHead>
              <TableRow>
                <StyledTableCell>SL NO</StyledTableCell>
                {tableprops.map((tableProp, i) => (
                  <StyledTableCell key={`customReportHead${i}`}>
                    {tableProp.heading}
                  </StyledTableCell>
                ))}
                {logProps && (
                  <StyledTableCell align="center">LOGS</StyledTableCell>
                )}

              </TableRow>
            </TableHead>
            <CustomTableBody
              alert={"No data found"}
              dataLoading={Boolean(isLoading)}
              isData={Boolean(renderdata.length > 0)} // Updated isData check
              totalSpan={{
                col: logProps ? tableprops.length + 2 : tableprops.length + 1,
                row: rowsPerPage,
              }}
            >
              {renderdata.map((item: any, i: number) => (
                <Fragment key={`outterFragment${i}`}>
                  {item?.data?.map((row: any, j: number) => (
                    <TableRow key={`customReportRow${i + j}`}>
                      <TableCell sx={{ borderLeft: "1px solid #ccc" }}>
                        {effectivePage * effectiveRowsPerPage + (j + 1)}
                      </TableCell>
                      {tableprops.map((tableProp, j) => (
                        <TableCell
                          align={"left"}
                          key={`customReportRow${i}Col${j}`}
                          sx={{ borderLeft: "1px solid #ccc" }}
                        >
                          {tableProp.key != "" && renderCellValue(row, tableProp)}
                        </TableCell>
                      ))}
                      {logProps && j == 0 && (
                        <TableCell
                          sx={{ borderLeft: "1px solid #ccc" }}
                          rowSpan={item?.data?.length}
                        >
                          <IconButton
                            color="primary"
                            onClick={() => {
                              handleOpenLog(`${item.encounterId}`);
                            }}
                          >
                            <ListAltIcon />
                          </IconButton>
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                  <TableCell
                    sx={{ borderLeft: "1px solid #ccc", p: 0 }}
                    colSpan={
                      logProps ? tableprops.length + 2 : tableprops.length + 1
                    }
                  >
                    <Collapse in={open == item?.encounterId}>
                      <TableContainer className="max-h-[65dvh] relative p-2">
                        <Table
                          size="small"
                          sx={{
                            minWidth: 650,
                            maxWidth: "85vw",
                            border: "1px solid #ccc",
                          }}
                          aria-label="simple table"
                        >
                          <TableHead
                            className="sticky top-0 z-[999]"
                            sx={(theme) => ({
                              backgroundColor: theme.palette.background.paper,
                            })}
                          >
                            <TableRow>
                              {headings.map((heading, index) => (
                                <TableCell key={`${title}Logs${index}`}>
                                  <strong>{heading}</strong>
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <CustomTableBody
                            alert={"No records"}
                            dataLoading={logLoading}
                            isData={Boolean(logs?.response?.length)}
                            totalSpan={{ col: headings.length, row: 10 }}
                          >
                            {logs?.response?.map((log, index) => (
                              <TableRow
                                sx={(theme) => ({
                                  "&:nth-of-type(odd)": {
                                    backgroundColor: theme.palette.action.hover,
                                  },
                                  // hide last border
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                })}
                              >
                                <TableCell key={`${titles[title]}log${index}`}>
                                  {log.id}
                                </TableCell>
                                <TableCell>{log.actionType}</TableCell>
                                <TableCell sx={{ maxWidth: "300px" }}>
                                  {String(log?.newValue || "").replace(
                                    /#\$/g,
                                    " ",
                                  )}
                                </TableCell>
                                <TableCell sx={{ maxWidth: "300px" }}>
                                  {String(log?.oldValue || "").replace(
                                    /#\$/g,
                                    " ",
                                  )}
                                </TableCell>
                                <TableCell>{log.fieldName}</TableCell>
                                <TableCell sx={{ maxWidth: "300px" }}>
                                  {formatLocalDateTime(log.timeStamp)}
                                </TableCell>
                                <TableCell sx={{ maxWidth: "300px" }}>
                                  {log.user}
                                </TableCell>
                              </TableRow>
                            ))}
                          </CustomTableBody>
                        </Table>
                      </TableContainer>
                    </Collapse>
                  </TableCell>
                </Fragment>
              ))}
            </CustomTableBody>
          </Table>
        </div>
      </CustomModal>
      <Tooltip title={`View ${title} history`}>
        {/* <IconButton  color="primary" disabled={isLoading} onClick={handleOpenHistory}>
                     <ListAlt/>
                </IconButton> */}
        <Button
          sx={{ fontSize: 10, px: 1, py: 0, textTransform: "none" }}
          size="small"
          variant="outlined"
          onClick={handleOpenHistory}
        >{`${title} history`}</Button>
      </Tooltip>
    </>
  );
};

export default HistoryComponent;

const titles = {
  Vitals: "vitals",
  Allergy: "allergy",
  Complaints: "complaints",
  "Medical History": "medicalHistory",
  "Social History": "socialHistory",
  "Family History": "familyHistory",
  "Physical Examination": "physicalExamination",
  lab: "lab",
  Radiology: "radiology",
  Diagnosis: "diagnosis",
  Problems: "problems",
  Procedures: "procedures",
  Prescription: "prescription",
  "Management Plan": "managementPlan",
  "Treatment Plan": "treatmentPlan",
  "clinical Impression": "clinicalImpression",
  "Upload Document": "uploadDocument",
  "Dental Procedure": "dentalProcedure",
};

const logApi = {
  diagnosis: "diagnosis",
  complaints: "complaints",
  socialHistory: "socialhistory",
  familyHistory: "familyhistory",
  prescription: "prescription",
  radiology: "radiologydetails",
  lab: "labdetails",
  problems: "problems",
  managementPlan: "managementplan",
  allergy: "allergy",
  medicalHistory: "medicalhistory",
  medicaldisease: "medicaldisease",
  ros: "ros",
  treatmentPlan: "treatmentplan",
  clinicalImpression: "clinicalimpression",
  procedures: "procedures",
};
